import React from 'react'
import { Link } from 'react-router-dom'
import { l } from '@manychat/manyui'

import { KnowledgeBaseLink } from 'common/core/components/SupportLinks'
import { typedRouting } from 'utils/router'

import cm from './common.module.css'

export const WAMessageTemplateCategoryChange = () => {
  return (
    <>
      <span className="m-r-xxs">
        {l.translate(
          `The category of one or more Message Templates was updated by Meta.
      This might influence <a href="{priceUrl}" target="_blank" rel="noreferrer" class="{class}">the price</a> of linked broadcasts. `,
          {
            priceUrl: KnowledgeBaseLink.WA_PRICING,
            class: cm.link,
          },
        )}
      </span>
      <Link
        to={typedRouting.linkBuilder.settings({ hash: 'whatsApp/templates' })}
        className={cm.link}
      >
        {l.translate('See all Message Templates')}
      </Link>
    </>
  )
}
